var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2947 21.649H15.3069M10.6774 27.1169H19.9121C21.2732 27.1169 21.9537 27.1169 22.4735 26.852C22.9308 26.619 23.3026 26.2473 23.5356 25.79C23.8004 25.2701 23.8004 24.5896 23.8004 23.2286V6.70325C23.8004 5.34222 23.8004 4.6617 23.5356 4.14185C23.3026 3.68458 22.9308 3.31281 22.4735 3.07982C21.9537 2.81494 21.2732 2.81494 19.9121 2.81494H10.6774C9.31634 2.81494 8.63582 2.81494 8.11597 3.07982C7.6587 3.31281 7.28693 3.68458 7.05394 4.14185C6.78906 4.6617 6.78906 5.34222 6.78906 6.70326V23.2286C6.78906 24.5896 6.78906 25.2701 7.05394 25.79C7.28693 26.2473 7.6587 26.619 8.11597 26.852C8.63582 27.1169 9.31634 27.1169 10.6774 27.1169ZM15.9023 21.649C15.9023 21.9845 15.6303 22.2565 15.2947 22.2565C14.9592 22.2565 14.6872 21.9845 14.6872 21.649C14.6872 21.3134 14.9592 21.0414 15.2947 21.0414C15.6303 21.0414 15.9023 21.3134 15.9023 21.649Z",
    stroke: "#F5F5F5",
    strokeWidth: 2.4302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3b15b1f5486b4c66d6f5fc94f6dd3a80.svg";
export { ForwardRef as ReactComponent };